"use client";

import { useState } from "react";
import { Modal, ModalContent, ModalHeader, ModalTitle, ModalDescription, ModalFooter } from "keep-react"

export const TempNote = () => {
  const [open, setOpen] = useState(true);
  return (
    <Modal open={open} onOpenChange={() => setOpen(!open)}>
      <ModalContent className="max-w-[20rem] lg:max-w-[26rem]">
        <ModalHeader className="mb-6 space-y-3">
         
          <div className="space-y-1">
            <ModalTitle>Wichtiger Hinweis:</ModalTitle>
            <ModalDescription>
            
<span className="block">Wow – die Nachfrage ist überwältigend! So viele möchten sich aktuell registrieren oder einloggen, dass es kurzfristig zu Einschränkungen kommt.</span>
<span className="block">Wir arbeiten mit Hochdruck daran, alles schnell wieder reibungslos zum Laufen zu bringen.</span>
<span className="block">Ihre Anfragen werden Schritt für Schritt bearbeitet. Bereits übertragene Umsätze und Registrierungen sind sicher und gehen nicht verloren.</span>
<span className="block">Versuchen Sie es gern in der kommenden Woche erneut – dann können Sie auf all Ihre Vorteile zugreifen. Es lohnt sich!</span>

            </ModalDescription>
          </div>
        </ModalHeader>
        <ModalFooter>
        Vielen Dank für Ihre Geduld und Ihr Verständnis ♥
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
